module.exports = __webpack_public_path__ + "4bf27e3dadbe2420b85e3a6ff5df9209.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/1000_r_30.mp3
// module id = 434
// module chunks = 0